import { render } from "./IconTooltip.vue?vue&type=template&id=1a7156e7"
import script from "./IconTooltip.vue?vue&type=script&lang=js"
export * from "./IconTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__